import React from 'react';

export enum TABS_TYPE {
  BILLING_CONTRACTS = 'billingContracts',
  GATEWAY_INVOICES = 'gatewayInvoices',
}

export interface ITabComponent {
  children: (data: {
    content: React.ReactNode;
    createComponent: React.ReactNode;
  }) => React.ReactElement;
}
